import { useEffect, useCallback, useRef } from "react";
import { ActiveCall, CallParticipant } from "../services/callManagementService";

interface CallNotificationEvents {
  onCallInitiated?: (data: { callId: string; callData: ActiveCall; timestamp: string }) => void;
  onUserJoinedCall?: (data: { callId: string; userId: string; timestamp: string }) => void;
  onUserLeftCall?: (data: { callId: string; userId: string; timestamp: string }) => void;
  onCallEnded?: (data: { callId: string; reason?: string; timestamp: string }) => void;
  onConnectionError?: (error: any) => void;
}

export const useCallNotifications = (
  userId: string | null,
  events: CallNotificationEvents = {}
) => {
  const eventsRef = useRef(events);

  // Update events ref when events change
  useEffect(() => {
    eventsRef.current = events;
  }, [events]);

  // WebSocket functionality removed
  useEffect(() => {
    if (!userId) {
      console.log("👤 No user ID provided, skipping call notifications setup");
      return;
    }

    console.log("🔌 Call notifications setup for user:", userId, "(WebSocket disabled)");

    // Cleanup on unmount
    return () => {
      console.log("🧹 Cleaning up call notifications");
    };
  }, [userId]);

  // Manual emit functions - WebSocket functionality removed
  const emitJoinUserRoom = useCallback(() => {
    // WebSocket functionality removed
  }, [userId]);

  const disconnect = useCallback(() => {
    // WebSocket functionality removed
  }, []);

  const isConnected = false; // WebSocket disabled

  return {
    socket: null,
    isConnected,
    emitJoinUserRoom,
    disconnect,
  };
};
